<template>
    <tr>
        <td class="editor-content editor-label">Text Size</td>
        <td class="editor-content">
            <select class="form-control editor-form editor-select" v-model="selectedComponent.style.size">
                <option value="size-xs">xs</option>
                <option value="size-sm">sm</option>
                <option value="size-md">md</option>
                <option value="size-lg">lg</option>
                <option value="size-2x">2x</option>
                <option value="size-3x">3x</option>
                <option value="size-4x">4x</option>
                <option value="size-5x">5x</option>
                <option value="size-6x">6x</option>
                <option value="size-7x">7x</option>
                <option value="size-8x">8x</option>
                <option value="size-9x">9x</option>
                <option value="size-10x">10x</option>
            </select>
        </td>
    </tr>
</template>

<script>
    export default {
        name: 'LabelSizeEditor',
        props: ['selectedComponent'],
        data () {
            return {
                model: webase.model
            }
        }
    }
</script>
